import { Float, TCredentialsType, TNodeEnv } from '/src/lib/types';

const getEnvironmentVariable = (unvalidatedEnvironmentVariable: string | undefined, defaultValue?: string): string => {
  if (!unvalidatedEnvironmentVariable) {
    if (defaultValue !== undefined) return defaultValue;
    throw new Error(`Couldn't find environment variable: ${unvalidatedEnvironmentVariable}`);
  } else {
    return unvalidatedEnvironmentVariable;
  }
};

export interface IConfig {
  nodeEnv: TNodeEnv;
  client: {
    url: string;
    basePageTitle: string;
  };
  api: {
    url: string;
    version: string;
    useCredentials: boolean;
    credentialsType: TCredentialsType;
  };
  logs: {
    rootNamespace: string;
  };
  urls: {
    fuseWebsiteUrl: string;
    fuseSupportUrl: string;
    privacyPolicyUrl: string;
    apiDataUrl: string;
  };
  maps: {
    nominatimUrl: string;
    googleMapsApiKey: string;
    cartoBasemapsApiKey: string;
  };
  sentry: {
    dsn: string;
    tracesSampleRate: Float;
    replaysSessionSampleRate: Float;
    replaysOnErrorSampleRate: Float;
  };
  stripe: {
    platformAccountId: string;
  };
  documents: {
    refreshIntervalMs: number;
  };
}

export const config: IConfig = {
  nodeEnv: getEnvironmentVariable(process.env.NODE_ENV) as TNodeEnv,
  client: {
    url: getEnvironmentVariable(process.env.CLIENT_URL, 'http://localhost:1234'),
    basePageTitle: getEnvironmentVariable(process.env.BASE_PAGE_TITLE, 'FuSE'),
  },
  api: {
    url: getEnvironmentVariable(process.env.API_URL),
    version: getEnvironmentVariable(process.env.API_VERSION),
    useCredentials: getEnvironmentVariable(process.env.API_USE_CREDENTIALS, 'false') === 'true',
    credentialsType: getEnvironmentVariable(process.env.API_CREDENTIALS_TYPE, 'include') as TCredentialsType,
  },
  logs: {
    rootNamespace: getEnvironmentVariable(process.env.LOGS_ROOT_NAMESPACE, 'fuse-frontend'),
  },
  urls: {
    fuseWebsiteUrl: getEnvironmentVariable(process.env.FUSE_WEBSITE_URL),
    fuseSupportUrl: getEnvironmentVariable(process.env.FUSE_SUPPORT_URL),
    privacyPolicyUrl: getEnvironmentVariable(process.env.PRIVACY_POLICY_URL),
    apiDataUrl: getEnvironmentVariable(process.env.API_DATA_URL),
  },
  maps: {
    nominatimUrl: getEnvironmentVariable(process.env.OPEN_STREET_MAPS_NOMINATIM_URL),
    googleMapsApiKey: getEnvironmentVariable(process.env.GOOGLE_MAPS_API_KEY, ''),
    cartoBasemapsApiKey: getEnvironmentVariable(process.env.CARTO_BASEMAPS_API_KEY, ''),
  },
  sentry: {
    dsn: getEnvironmentVariable(process.env.SENTRY_DSN_URL),
    tracesSampleRate: parseFloat(getEnvironmentVariable(process.env.TRACES_SAMPLE_RATE, '1.0')),
    replaysSessionSampleRate: parseFloat(getEnvironmentVariable(process.env.REPLAYS_SESSION_SAMPLE_RATE, '0.1')),
    replaysOnErrorSampleRate: parseFloat(getEnvironmentVariable(process.env.REPLAYS_ON_ERROR_SAMPLE_RATE, '1.0')),
  },
  stripe: {
    platformAccountId: getEnvironmentVariable(process.env.STRIPE_PLATFORM_ACCOUNT_ID, ''),
  },
  documents: {
    refreshIntervalMs: parseInt(getEnvironmentVariable(process.env.DOCUMENT_REFRESH_INTERVAL_MS, '5000'), 10) || 5000,
  },
};
